<template>
  <div class="content">

      <div class="container-fluid mt-4">

          <stats-card title="Report details" type="default" :sub-title="reportData.name" icon="fas fa-clipboard-list">

            <template slot="actions">
                <a class="dropdown-item" v-if="reportData.status != 'active'" @click="onResumeReport">Resume Report</a>
                <a class="dropdown-item" v-if="reportData.status == 'active'" @click="onPauseReport">Pause Report</a>
                <a class="dropdown-item" v-if="reportData.status != 'deleted'" @click="showDeleteModal = true">Delete Report</a>
            </template>

            <template slot="append">

                <base-alert type="warning" v-if="reportData.status =='paused'">
                    This report is currently <strong>paused</strong>
                </base-alert>

                <base-alert type="danger" v-if="reportData.status =='deleted'">
                    This report is currently <strong>deleted</strong>
                </base-alert>

                <b-card no-bod class="tab-wrapper">

                  <b-card-header header-tag="nav">
                      <b-nav card-header tabs>
                          <b-nav-item @click="setActiveTab(2)" :active="activeTab == 2">
                              Report Details
                          </b-nav-item>
                          <b-nav-item @click="setActiveTab(1)" :active="activeTab == 1">
                              <i class="fas fa-tree"></i>
                              Orchards
                          </b-nav-item>
                          <b-nav-item @click="setActiveTab(3)" :active="activeTab == 3">
                              <i class="fas fa-paper-plane"></i>
                              Recipients
                          </b-nav-item>
                            <b-nav-item @click="setActiveTab(4)" :active="activeTab == 4">
                              <i class="fas fa-stream"></i>
                               Logs
                          </b-nav-item>
                      </b-nav>
                  </b-card-header>

                  <div class="tab-container">

                    <!-- LOGS TAB -->
                    <div class="mt-3" v-if="activeTab == 4">

                        <div v-if="reportData.logs.length > 0">

                            <div class="form-group">
                                <label class="form-control-label">Log type:</label>
                                <b-form-select v-on:change="onLogTypeChange" v-model="reportLogType" :options="reportLogTypes"></b-form-select>
                            </div>

                            <stats-card :icon="`fas fa ${!log.status.isSuccess ? 'fa-exclamation-circle' : 'fa-check-circle'}`" :type="!log.status.isSuccess ? 'warning' : 'success'" class="reportLogEntry" :sub-title="getReportDate(log.completedOn)" :title="`${log.status.isSuccess ? 'Success' : 'Issue'}`" v-for="log in updatedReportData.logs" :key="log.completedOn">
                                <template slot="append">

                                    <base-alert type="warning" v-if="log.status.forgottenRecipients.length > 0">
                                        {{log.status.forgottenRecipients.join(', ')}} <strong>did not receive this report</strong>
                                    </base-alert>

                                    <base-alert type="info">
                                        <strong>Report was sent to: </strong> {{log.status.recipients.join(', ')}}
                                    </base-alert>
                                </template>
                            </stats-card>
                        </div>

                        <base-alert type="info" v-else>
                            No logs yet for this report!
                        </base-alert>

                    </div>

                    <!-- ORCHARDS TAB -->
                    <div class="mt-3" v-if="activeTab == 1">
                        <entity-picker
                            v-if="updatedReportData.groups.length"
                            @onSelect="handleGroupUpdate"
                            placeHolder="Search to add an orchard"
                            apiEndpoint="getGroups"
                            :multiple="true"
                            :selected="updatedReportData.groups"
                            :canBeEmpty="true"
                            rootProp="orchards"
                            :canEdit="true"
                            editPath="/groups/"
                            key="groupPicker"
                        >
                        </entity-picker>
                    </div>

                    <!-- USERS TAB -->
                    <div class="mt-3" v-if="activeTab == 3">
                        <entity-picker
                            v-if="updatedReportData.recipients.length"
                            @onSelect="handleRecipientUpdate"
                            placeHolder="Search to add a user"
                            apiEndpoint="getUsers"
                            :multiple="true"
                            :selected="updatedReportData.recipients"
                            :canBeEmpty="true"
                            :tableColumns="userTableColumns"
                            rootProp="users"
                            :canEdit="true"
                            editPath="/users/"
                            key="userPicker"
                        >
                        </entity-picker>
                    </div>

                    <!-- DETAILS TAB -->
                    <div class="mt-3" v-if="activeTab == 2">

                      <base-alert>
                        This report was created on {{getCreatedDate()}}
                      </base-alert>

                        <base-input label="Name:" v-model="updatedReportData.name"></base-input>

                        <div class="form-group">
                            <label class="form-control-label">Frequency:</label>
                            <b-form-select v-model="updatedReportData.schedule" :options="reportFrequencies"></b-form-select>
                        </div>

                        <div class="form-group">
                            <label class="form-control-label">Time of day:</label>

                            <el-select class="select-primary pagination-select" v-model="updatedReportData.timeOfDay" placeholder="Pick an hour">
                                <el-option
                                class="select-primary"
                                v-for="(item,index) in updatedReportData.possibleHours"
                                :key="index"
                                :label="item"
                                :value="parseInt(index)"
                                >
                                </el-option>
                            </el-select>
                        </div>

                        <div class="form-group" v-if="updatedReportData.isWeekly">
                            <label class="form-control-label">Day of week:</label>
                            <el-select class="select-primary pagination-select" v-model="updatedReportData.dayOfWeek" placeholder="Pick a day">
                                <el-option
                                class="select-primary"
                                v-for="(item,index) in updatedReportData.possibleDays"
                                :key="index"
                                :label="item"
                                :value="parseInt(index)"
                                >
                                </el-option>
                            </el-select>
                        </div>

                      <div class="form-group" v-if="updatedReportData.isMonthly">
                        <label class="form-control-label">Day of the month:</label>
                        <el-select class="select-primary pagination-select" v-model="updatedReportData.dayOfWeek" placeholder="Pick a day">
                          <el-option
                            class="select-primary"
                            v-for="(item,index) in 28"
                            :key="index"
                            :label="item"
                            :value="parseInt(item)"
                          >
                          </el-option>
                        </el-select>
                      </div>


                      <div class="form-group">
                            <label class="form-control-label">Delivery Type:</label>
                            <el-select class="select-primary pagination-select" v-model="updatedReportData.deliveryType" placeholder="Pick a delivery method">
                                <el-option
                                class="select-primary"
                                v-for="(item,index) in updatedReportData.possibleDeliveryTypes"
                                :key="index"
                                :label="item"
                                :value="parseInt(index)"
                                >
                                </el-option>
                            </el-select>
                        </div>

                        <div class="mt-3" align="right">
                            <base-button type="primary" @click="updateReport">
                                Update details
                            </base-button>
                        </div>
                  </div>

                  </div>

                </b-card>

            </template>

          </stats-card>

      </div>

    <modal :show.sync="showDeleteModal">
        <h6 slot="header" class="modal-title">Delete Report</h6>

        <base-alert type="danger">
            Are you sure you want to <strong>delete</strong> this report?
        </base-alert>

        <template slot="footer">
            <base-button type="blank" @click="showDeleteModal = false">Cancel</base-button>
            <base-button type="danger" @click="deleteReport">Yes, delete</base-button>
        </template>
    </modal>



  </div>

</template>

<style lang="scss" scoped>
.success {
    color: green;
}
.failure {
    color: red;
}
.notApplicable {
    color: lightslategray;
}
</style>

<script>
import api from '@/api'
import { Select, Option } from 'element-ui'
import { userTableColumns } from '@/config/ReportUserTable'
import { TimeHelper } from '@/helpers/TimeHelper'
import { ReportModel } from '@/models/report/report'
import { tableColumns, tableFilters, tableOptions } from '@/config/ReportTable'

export default {
  components: {
      [Select.name]: Select,
      [Option.name]: Option,
  },
  data() {
    return {
      reportLogType: 'all',
      reportHours: [
          8,9,10,11,12,13,14,15,16,17,18,19
      ],
      reportTypes: [
          'flyrt',
          'detections'
      ],
      reportFrequencies: [
          'daily',
          'weekly',
          'monthly'
      ],
      reportLogTypes: [
          'all',
          'issues',
          'success'
      ],
      userTableColumns: userTableColumns,
      showChangeOrg: false,
      pickedDate: '',
      groups: [],
      originalGroups: [],
      reportData: null,
      updatedReportData: null,
      activeTab: 2,
      deleteOrchards: true,
      showDeleteModal: false,
      detections: [],
      tableOptions: tableOptions
    };
  },
  created: async function() {
    this.fetchReport()
  },
  methods: {
    onLogTypeChange(value) {
        this.setReportLogsStatus()
    },
    getReportEntryStatus(entry) {
        let isEmailError = entry.logs.filter((e) => e.emailSent == false).length > 0
        let entryRecipients = this.reportData.recipients.filter((r) => r.createdOn < entry.completedOn).map((r) => r.email)
        let entrySentTo =  entry.logs.filter((l) => entryRecipients.includes(l.recipient.email)).map((l) => l.recipient.email)
        let entryRecip = entry.logs.map((l) => l.recipient.email)
        let isRecipientError = entrySentTo.length < entryRecipients.length
        return {
            isRecipientError,
            isEmailError,
            isSuccess: !isRecipientError && !isEmailError,
            forgottenRecipients: entryRecipients.filter(x => !entrySentTo.includes(x)),
            recipients: entryRecip
        }
    },
    onPauseReport: async function() {
        this.updatedReportData.status = 'paused'
        this.updateReport()
    },
    onResumeReport: async function() {
        this.updatedReportData.status = 'active'
        this.updateReport()
    },
    getCreatedDate() {
        return TimeHelper.formatDate(this.reportData.createdOn)
    },
    getReportDate(timestamp) {
        return TimeHelper.formatDate(timestamp)
    },
    fetchReport: async function() {
        this.$emit('loading', true);
        const results = await api.getReport(this.$route.params.id)
        this.$emit('loading', false);
        this.reportData = new ReportModel(results)
        this.updatedReportData = new ReportModel(results)
    },
    fetchReportLogs: async function() {
        // we'll need recipients
        if(this.reportData.recipients.length == 0) {
            await this.fetchReportRecipients();
        }
        this.$emit('loading', true);
        const logs = await api.getReportLogs(this.$route.params.id)
        this.reportData.logs = JSON.parse(JSON.stringify(logs))
        // this.updatedReportData.logs = JSON.parse(JSON.stringify(logs))
        this.setReportLogsStatus()
        this.$emit('loading', false);
    },
    setReportLogsStatus() {
        this.updatedReportData.logs = []
        for(let index in this.reportData.logs) {
            let entryStatus = this.getReportEntryStatus(this.reportData.logs[index])
            this.updatedReportData.logs[index] = {
                ... this.reportData.logs[index],
                status: entryStatus
            }
        }
        if(this.reportLogType == 'issues') this.updatedReportData.logs = this.updatedReportData.logs.filter((l) => !l.status.isSuccess)
        if(this.reportLogType == 'success') this.updatedReportData.logs = this.updatedReportData.logs.filter((l) => l.status.isSuccess)
    },
    fetchReportGroups: async function() {
        this.$emit('loading', true);
        const groups = await api.getReportGroups(this.$route.params.id)
        this.reportData.groups = JSON.parse(JSON.stringify(groups))
        this.updatedReportData.groups = JSON.parse(JSON.stringify(groups))
        this.$emit('loading', false);
    },
    fetchReportRecipients: async function() {
        this.$emit('loading', true);
        const recipients = await api.getReportRecipients(this.$route.params.id)
        this.reportData.recipients = JSON.parse(JSON.stringify(recipients))
        this.updatedReportData.recipients = JSON.parse(JSON.stringify(recipients))
        this.$emit('loading', false);
    },
    setActiveTab: async function(tab) {
        if(tab == 1) {
            if(this.reportData.groups.length == 0) {
                this.fetchReportGroups();
            }
        }
        if(tab == 3) {
            if(this.reportData.recipients.length == 0) {
                this.fetchReportRecipients();
            }
        }
        if(tab == 4) {
            if(this.reportData.logs.length == 0) {
                this.fetchReportLogs();
            }
        }
        this.activeTab = tab
    },
    handleRecipientUpdate: async function(recipients) {
        let originalRecipientsIds = this.reportData.recipients.map((o) => o.id)
        let updatedRecipientsIds = recipients.map((g) => g.id)

        let addedRecipients = recipients.filter((g) => !originalRecipientsIds.includes(g.id))
        let removedRecipients = this.reportData.recipients.filter((g) => !updatedRecipientsIds.includes(g.id))

        if(addedRecipients.length > 0 || removedRecipients.length > 0) {
            this.$emit('loading', true);

            if(addedRecipients.length > 0) {
                await api.addReportRecipients(this.$route.params.id,addedRecipients.map((g) => {
                    return {
                        userId: g.id
                    }
                }))
                this.$emit('onApiResult', `${addedRecipients.length} user(s) added to report`);
            }

            if(removedRecipients.length > 0) {
                await api.removeReportRecipients(this.$route.params.id,removedRecipients.map((g) => {
                    return {
                        userId: g.id
                    }
                }))
                this.$emit('onApiResult', `${removedRecipients.length} user(s) removed from report`);
            }
            this.fetchReportRecipients();
        }
    },
    handleGroupUpdate: async function(groops) {
        let originalGroupsIds = this.reportData.groups.map((o) => o.id)
        let updatedGroupsIds = groops.map((g) => g.id)

        let addedGroups = groops.filter((g) => !originalGroupsIds.includes(g.id))
        let removedGroups = this.reportData.groups.filter((g) => !updatedGroupsIds.includes(g.id))

        if(addedGroups.length > 0 || removedGroups.length > 0) {
            this.$emit('loading', true);

            if(addedGroups.length > 0) {
                await api.addReportGroups(this.$route.params.id,addedGroups.map((g) => {
                    return {
                        groupId: g.id
                    }
                }))
                this.$emit('onApiResult', `${addedGroups.length} orchard(s) added to report`);
            }

            if(removedGroups.length > 0) {
                await api.removeReportGroups(this.$route.params.id,removedGroups.map((g) => {
                    return {
                        groupId: g.id
                    }
                }))
                this.$emit('onApiResult', `${removedGroups.length} orchard(s) removed from report`);
            }

            this.fetchReportGroups();
        }
    },
    updateReport: async function() {
        this.$emit('loading', true);
        await api.updateReport(this.reportData.id,this.updatedReportData.toDetailsUpdateJson(this.reportData))
        this.fetchReport()
        this.$emit('onApiResult', "Report has been updated");
    },
    deleteReport: async function() {
        this.showDeleteModal = false
        this.updatedReportData.status = 'deleted'
        this.updateReport()
    },
    activateReport: async function() {
        this.updatedReportData.status = 'active'
        this.updateReport()
    }

  }
};
</script>
